import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import {Reviews} from "./components/Reviews";
import {Services} from "./components/Services";


function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Services/>
      <Skills />
      <Projects />
    
      <Reviews/>
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
